import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PickupsList from "./PickupsList";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import { Pickup } from "../../../type/entities/pickup-type";
import cn from "../../../utils/classNames";
import PickupsImportModal from "../components/PickupsImportModal";

const PickupsListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [pickupSelected, setPickupSelected] = useState<Pickup | null>(null);
    const [isOpenImportModal, setIsOpenImportModal] = useState(false);
    const pickupsTableRefetchRef = useRef<(() => void) | null>(null);
    const defaultFilters = {};

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de recogidas' },
        { name: 'Recogidas', href: menuRoutes.pickups.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const registerTableRefetch = useCallback((fn: () => void) => {
        pickupsTableRefetchRef.current = fn;
    }, []);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de recogidas" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                        {
                            userCan('create', 'provider') &&
                            (
                                <Button
                                    variant="outline"
                                    onClick={() => setIsOpenImportModal(true)}
                                >
                                    Importar Excel
                                </Button>
                            )
                        }
                        {
                            userCan('create', 'pickup') &&
                            (
                                <Button
                                    color="primary"
                                    onClick={() => { 
                                        setIsOpenFormDrawer(true) 
                                        setPickupSelected(null)
                                    }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear recogida
                                </Button>
                            )
                        }
                    </div>
                </PageHeader>
                <PickupsList
                    openFormDrawer={isOpenFormDrawer}
                    setOpenFormDrawer={setIsOpenFormDrawer}
                    pickupSelected={pickupSelected}
                    setPickupSelected={setPickupSelected}
                    registerTableRefetch={registerTableRefetch}
                />
                <PickupsImportModal 
                    isOpen={isOpenImportModal} 
                    onClose={() => setIsOpenImportModal(false)} 
                    refetch={() => {
                        pickupsTableRefetchRef.current?.();
                    }} 
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default PickupsListWrapper;